<!-- 相似图片 -->
<template>
    <div class="similar_photo" v-show="simlarPic!== undefined &&simlarPic.length >0">
        <h1 class="title">相似图片</h1>
        <ul class="simlar_list clearfix">
            <li v-for="(item,index) in simlarPic" :key="index">
                <router-link tag="a" :to="'/picDetail?id='+item.FileNo+'&sourceType=1&fId='+item.Id">
                    <div class="container">
                        <img :src="item.CoverImg" />
                    </div>
                </router-link>

            </li>
        </ul>
    </div>
</template>

<script>
import { getSimlarPic } from "../../assets/js/modules/fileApi"
export default {
    props: {
        id: {//文件id

        },
        MediumCId:{},
        filType:""
    },
    data() {
        return {
            simlarPic: [],
            defaultNum: 12, //默认显示个数
            pageNum: 1, //每次加载个数
            scrollFlag: false
        };
    },
    mounted() {
        this.simlarPicDel();
        this.$nextTick(() => {
            var self = this;
            window.addEventListener('scroll', function() {
                if (self.getScrollTop() + self.getClientHeight() == self.getScrollHeight()) {
                    // self.scrollFlag=true;
                    // self.simlarPicDel();
                    // self.defaultNum = self.defaultNum + 8;
                    // self.picInfo = self.picInfo.concat(res.data.Data.listFile);
                }
            })
        })
    },
    methods: {
        //获取滚动条当前的位置 
        getScrollTop() {
            var scrollTop = 0;
            if (document.documentElement && document.documentElement.scrollTop) {
                scrollTop = document.documentElement.scrollTop;
            } else if (document.body) {
                scrollTop = document.body.scrollTop;
            }
            return Math.round(scrollTop);
        },

        //获取当前可视范围的高度 
        getClientHeight() {
            var clientHeight = 0;
            if (document.body.clientHeight && document.documentElement.clientHeight) {
                clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
            } else {
                clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
            }
            return clientHeight;
        },

        //获取文档完整的高度  
        getScrollHeight() {
            return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        },
        simlarPicDel() {
            let data = {
                Id: this.id,  //文件主键Id
                PageIndex: 1,  //页码
                PageSize: this.defaultNum, //每页多少条数据
                FileType:this.filType,
                MediumCategoryId:this.MediumCId,
            }
            if (this.scrollFlag) {
                this.pageNum += 1;
            }
            getSimlarPic(data).then(res => {
                if (res.data.Code==1) {
                    this.simlarPic = res.data.Data.Items;
                }
                
            })
        }
    },
}

</script>
<style  scoped>
.similar_photo {
    width: 100%;
    max-width: 1280px;
    margin: 36px auto;
}

.similar_photo .title {
    height: 44px;
    line-height: 44px;
    font-size: 16px;
    color: #666;
    border-bottom: 1px solid #e7e7e7;
}

.simlar_list {
    /* display: flex;
    flex-wrap: wrap;
    justify-content: space-between; */
}

.simlar_list li {
    width: 305px;
    height: 230px;
    /* flex: 0 0 305px; */
    float: left;
    margin-top: 20px;
    margin-right: 16px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 0px 10px 0px rgba(233, 233, 233, 0.5);
    position: relative;
}

.container {
    position: absolute;
    width: 285px;
    height: 205px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
}

.simlar_list li img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
}

@media (min-width: 1280px) {
    .simlar_list li:nth-child(4n) {
        margin-right: 0;
    }
}

@media (min-width: 963px) and (max-width: 1280px) {
    .simlar_list li:nth-child(3n) {
        margin-right: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/similarPhoto.vue